// https://github.com/growthbook/growthbook/blob/
// cc80c18db974742b86eea9e47520fc8591f4f3ab/packages/sdk-js/src/plugins/
// auto-attributes.ts#L146
export function genUUID(crypto) {
  crypto = crypto || window.crypto
  if (crypto && crypto.randomUUID) return crypto.randomUUID()

  // Fallback implementation for older browsers
  const template = String(1e7) + -1e3 + -4e3 + -8e3 + -1e11
  return template.replace(/[018]/g, char => {
    const digit = parseInt(char, 10)

    // Get random number (0-255)
    const randomByte = crypto && crypto.getRandomValues ?
      crypto.getRandomValues(new Uint8Array(1))[0] :
      Math.floor(Math.random() * 256)

    // Apply UUID version 4 bit manipulation
    const result = digit ^ (randomByte & (15 >> (digit / 4)))

    return result.toString(16)
  })
}
